import styled from 'styled-components/macro';

export const ScDownloadWrapper = styled.div`
  width: 85px;
  height: 48px;
  background: var(--main-gray);
  border: 1px solid var(--main-gray);
  border-radius: 10px;
  cursor: pointer;
`;
